import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { usePlanScreens } from "./usePlanScreens";

/**
 * Chặn đường dẫn của một màn hình không có trong gói của phòng khám (ADR-0053).
 *
 * <p>Ẩn menu chỉ tránh cho người dùng một ngõ cụt; nó không ngăn ai gõ thẳng URL hay mở một liên
 * kết cũ. Bộ chặn này đưa họ tới trang giải thích thay vì một trang rỗng đầy lỗi 402.
 *
 * <p>Đây vẫn là lớp trình bày. Thứ thật sự ngăn dữ liệu bị đọc hay ghi là chốt chặn ở từng endpoint.
 *
 * <p>Chưa có câu trả lời thì chưa vẽ trang: vẽ trước rồi mới chặn là bắn đi đúng những request sẽ
 * bị từ chối.
 */
export function PlanRouteGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const plan = usePlanScreens();

  if (!plan.settled) {
    return null;
  }
  if (!plan.allowsPath(location.pathname)) {
    return <Navigate to="/402" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
